/**
 * This functions converts unicode codepoint to emoji
 * e.g 1f935 -> 🤵
 * @param unicode
 * @returns {string}
 */
export default unicode => {
  const unicodes = unicode.split('-').map(char => parseInt(char, 16))
  return String.fromCodePoint(...unicodes)
}
